import React from "react";

import Heading from "core/Heading";
import PendingGroups from "./PendingGroups";

import useSubmissionsCounts from "./useSubmissionsCounts";

const SubmissionsPending = () => {
    const { pendingCount: totalCount } = useSubmissionsCounts();

    let content = null;

    if (!totalCount)
        content = (
            <Heading size="md">
                No photos currently queued for moderation.
            </Heading>
        );
    else {
        content = <PendingGroups data-testid="submissions-pending" />;
    }

    return <div data-testid="submissions-pending">{content}</div>;
};

export default SubmissionsPending;
